module.exports = "/info/img/value1.svg";